export default {
    FISICA: 'Física',
    JURIDICA: 'Jurídica'
}
